import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var BpgMembershipService = /** @class */ (function () {
    function BpgMembershipService(http, 
    // private logger: BPGLoggerService,
    bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.URI = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.bpgApi = ConstantValues.membershipApiUrl.bpgList;
        this.interestApi = ConstantValues.membershipApiUrl.interestList;
        this.skillsApi = ConstantValues.membershipApiUrl.skillsList;
        this.demographicApi = ConstantValues.membershipApiUrl.demographicLIst;
        this.membershipFormSaveApi = ConstantValues.membershipApiUrl.membershipSaveApi;
        this.retrieveDetailsOfMembershipForm = ConstantValues.membershipApiUrl.retrieveDetailsOfMembershipForm;
        this.landingDto = ConstantValues.membershipApiUrl.landingDto;
        this.virtualBpgUrl = ConstantValues.membershipApiUrl.excludeBpgApi;
        this.retrieveUserDetailsOfGroupMembership = ConstantValues.userManagementApiUrl.getMembershipGroupSignUpUserDetails;
        this.saveUserDetailsOfGroupMembership = ConstantValues.userManagementApiUrl.saveMemberhsipGroupDetails;
        this.saveAdminBpgSettings = ConstantValues.userManagementApiUrl.saveAdminBpgSettings;
        this.pastEnrollmentListApi = ConstantValues.userManagementApiUrl.getPastEnrollmentList;
        this.enrollmentDeleteApi = ConstantValues.userManagementApiUrl.deleteEnrollment;
    }
    /** For service call to get bpg list
    * @class MembershipService
    * @method getAllBpg
    * @param landingData
    * @returns Observable
    */
    BpgMembershipService.prototype.getAllBpg = function (landingDTOModel) {
        return this.http.post(this.URI + this.bpgApi, landingDTOModel, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get bpg list
    * @class MembershipService
    * @method getExcludedBpg
    * @param userId
    * @returns Observable
    */
    BpgMembershipService.prototype.getAllVirtualBpg = function (params) {
        return this.http.get(this.URI + this.virtualBpgUrl + params, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get areas of impact
   * @class MembershipService
   * @method getAreasOfImpact
   * @param landingData
   * @returns Observable
   */
    BpgMembershipService.prototype.getAreasOfImpact = function () {
        return this.http.post(this.URI + this.interestApi, this.landingDto, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get skills
 * @class MembershipService
 * @method skills
 * @param landingData
 * @returns Observable
 */
    BpgMembershipService.prototype.getSkills = function () {
        return this.http.post(this.URI + this.skillsApi, this.landingDto, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get demographics
   * @class MembershipService
   * @method demographics
   * @param landingData
   * @returns Observable
   */
    BpgMembershipService.prototype.getDemographics = function () {
        return this.http.post(this.URI + this.demographicApi, this.landingDto, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save membershipform
   * @class MembershipService
   * @method saveMembershipForm
   * @param finalFormData
   * @returns Observable
   */
    BpgMembershipService.prototype.saveMembershipForm = function (formData) {
        return this.http.post(this.URI + this.membershipFormSaveApi, formData, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to retrieve membershipform
      * @class MembershipService
      * @method retrieveDetailsOfMembership
      * @param userId
      * @returns Observable
      */
    BpgMembershipService.prototype.retrieveDetailsOfMembership = function (userId) {
        return this.http.post(this.URI + this.retrieveDetailsOfMembershipForm + userId, {}, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to retrieve user details in membership group singup
      * @class MembershipService
      * @method retrieveUserDetails
      * @param workdayId/badgeId
      * @returns Observable
      */
    BpgMembershipService.prototype.fetchUserDetialsForMembershipGroupSignUp = function (userData) {
        return this.http.post(this.URI + this.retrieveUserDetailsOfGroupMembership, userData, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save user details in membership group singup
  * @class MembershipService
  * @method saveUserDetails
  * @param userbpgdata
  * @returns Observable
  */
    BpgMembershipService.prototype.saveUserDetialsForMembershipGroupSignUp = function (membershipData) {
        return this.http.post(this.URI + this.saveUserDetailsOfGroupMembership, membershipData, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save bpg settings in membership group singup
* @class MembershipService
* @method saveBpgSettings
* @param bpgSettingsData
* @returns Observable
*/
    BpgMembershipService.prototype.saveBpgSettingsForAdmin = function (bpgSettingsData) {
        return this.http.post(this.URI + this.saveAdminBpgSettings, bpgSettingsData, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to fetch past enrollments data in membership group singup
* @class MembershipService
* @method fetchPastEnrollmentsData
* @param userId
* @returns Observable
*/
    BpgMembershipService.prototype.fetchPastEnrollmentsData = function (userId) {
        return this.http.get(this.URI + this.pastEnrollmentListApi + userId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to delete enrollmentin membership group singup
* @class MembershipService
* @method deleteEnrollment
* @param mappingId
* @returns Observable
*/
    BpgMembershipService.prototype.deleteEnrollment = function (mappingId) {
        return this.http.delete(this.URI + this.enrollmentDeleteApi + mappingId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BpgMembershipService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BpgMembershipService_Factory() { return new BpgMembershipService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: BpgMembershipService, providedIn: "root" });
    return BpgMembershipService;
}());
export { BpgMembershipService };
